import { configureStore } from "@reduxjs/toolkit";

export interface IAuthStoreData{
    role: "visitor" | "admin";
    identity: string;
    id: number;
    accessToken: string;
    refreshToken: string;
}

const DefaultAuthStoreData: IAuthStoreData = {
    role: "visitor",
    identity: "",
    id: 0,
    accessToken: "",
    refreshToken: "",
}

let initialAuthStoreData: IAuthStoreData = DefaultAuthStoreData;

(() => {
    if(!localStorage.getItem("app-auth-store-data")) {
        return {};
    }

    const storedData = JSON.parse(localStorage.getItem("app-auth-store-data") ?? "{}");

    if(typeof storedData !== "object") {
        return {};
    }
    initialAuthStoreData = {...initialAuthStoreData, ...storedData};
})();

type TUpdateRoles = {type: "update", key: "roles", value: "visitor" | "admin" };
type TUpdateId = {type: "update", key: "id", value: number};
type TUpdateStrings = {type: "update", key: "identity" | "accessToken" | "refreshToken" | "language", value: string};
type TReset = {type: "reset"};

type TAuthStoreAction = TUpdateRoles | TUpdateId | TUpdateStrings | TReset;

function AuthStoreReducer(state: IAuthStoreData = initialAuthStoreData, action: TAuthStoreAction){
    switch(action.type) {
        case "update": return {...state, [action.key]: action.value};
        case "reset": return {...DefaultAuthStoreData}
        default: return {...state} as IAuthStoreData;
    }
}

const AuthStore = configureStore({
    reducer: AuthStoreReducer
});

AuthStore.subscribe(() => {
    localStorage.setItem("app-auth-store-data", JSON.stringify(AuthStore.getState()));
});

export type TAuthStoreDispatch = typeof AuthStore.dispatch;
export default AuthStore;